import { createContext } from 'react';

const RadioContext = createContext({
    onChange: undefined,
    name: '',
    size: 'M',
    selected: '',
});

export { RadioContext };
